module.exports = __webpack_public_path__ + "img/2015005.6cc280d6.svg";